import { solveRadioGroup } from "@/directive";
import routeMetaMixin from "@/mixin/routeMetaMixin.js";
import {
  newsTitle,
  pageHead,
  consult,
  pagination,
  gaoDeMap,
  slideshow,
} from "@/components";

const components = {
  newsTitle,
  pageHead,
  consult,
  pagination,
  gaoDeMap,
  slideshow,
};

export default {
  install(Vue) {
    Object.keys(components).forEach((key) => {
      Vue.component(key, components[key]);
    });

    solveRadioGroup();

    Vue.mixin(routeMetaMixin);
  },
};
